import React from "react";
import classNames from "classnames";
import { getSimpleTitle } from "./utils.js";
import "./index.scss";
export default function Title(props) {
  var pid = props.pid,
    eurl = props.eurl,
    title = props.title,
    templateId = props.templateId;
  var simpleTitle = title ? getSimpleTitle(title) : "";
  /**
   * title展示规则
   * pc sem & 底部推荐 & pc主搜右侧DpaCpvOffer模板，只展示一行标题
   * pc sem pid 老: 819336_1008
   * pc sem pid 品专: 220123_2000 
   * pc sem pid 导航: 220123_3000
   * 底部推荐 pid 老: 819380_1008
   * 底部推荐 pid 品专: 220123_2001
   * 底部推荐 pid 导航: 220123_3001
   * 标王  pid: 819960_1008
   *
   * pc主搜右侧 pid: 819036_1008
   * TemptemplateId = 1000002
   */
  var showInOneLine = pid === "819336_1008" || pid === "819380_1008" || pid === "819960_1008" || pid === "220123_2000" || pid === "220123_3000" || pid === "220123_2001" || pid === "220123_3001" || pid === "819036_1008" && templateId === "1000002";
  var titleContentClass = classNames("zr-title-content", {
    "show-one-line": showInOneLine
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "zr-title",
    style: {
      height: showInOneLine ? "20px" : "40px"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: eurl,
    target: "_blank",
    title: simpleTitle
  }, /*#__PURE__*/React.createElement("span", {
    className: titleContentClass,
    dangerouslySetInnerHTML: {
      __html: title
    }
  })));
}